import type { ComputedRef, InjectionKey } from 'vue';

/** Cell size: `s` for stickers and small thumbnails, `m` for GIFs and pictures. */
export type NxMediaCellSize = 's' | 'm';

/** Set by `NxMediaGrid`: its cells share one tab stop and the grid's size. */
export interface NxMediaGridContext {
  /** The grid's cell size; a cell's own `size` wins. */
  size: ComputedRef<NxMediaCellSize>;
  /** The cell button that takes Tab; null while no enabled cell exists. */
  tabStop: ComputedRef<HTMLElement | null>;
  register(button: HTMLElement, disabled: () => boolean): void;
  unregister(button: HTMLElement): void;
  /** Makes the cell the tab stop (it got the focus or was clicked). */
  activate(button: HTMLElement): void;
}

export const mediaGridKey: InjectionKey<NxMediaGridContext> = Symbol('nx-media-grid');
